// extracted by mini-css-extract-plugin
export default {"card":"Card_card__zQfcO","flat":"Card_flat__b0tkg","elevated":"Card_elevated__uXHZO"};